import { ImageHelper, type IHeroComponentModel } from "@nf/common";
import { ROUTES } from "@nf/constants";
import React from "react";
import Image from "next/future/image";
import dynamic from "next/dynamic";
import { LinkWithLocale } from "../../../LinkWithLocale";
import LandingPageHeader from "./components/LandingPageHeader";

import styles from "./LandingPageSignUp.module.scss";

const SignUpForm = dynamic(() => import("./components/SignUpForm"));

interface LandingPageSignUpProps {
  component: IHeroComponentModel;
}

export const LandingPageSignUp = ({ component }: LandingPageSignUpProps) => {
  const backgroundImage = ImageHelper.getHighlightsImageUrl(
    component.MediaList?.[0].Images,
    null
  );

  return (
    <>
      <LandingPageHeader />
      <div className={styles.signUpContainer}>
        <LinkWithLocale href={ROUTES.HOME}>
          <a className={styles.background}>
            <Image
              alt=""
              src={backgroundImage || ""}
              priority={true}
              quality={100}
              sizes="100vw"
              fill={true}
              className={styles.image}
            />
          </a>
        </LinkWithLocale>
        <div className={styles.formContainer}>
          <SignUpForm title={component.MediaList?.[0].Title} />
        </div>
      </div>
    </>
  );
};
